import {Component, OnInit, ViewChild} from '@angular/core';
import {TdoTableSelectionEvent} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {ToothConfigurationModel} from '../../../../models/teeth/tooth-configuration.model';
import {ToothService} from '../../../../services/tooth.service';
import {MtiService} from '../../../../services/form/mti.service';
import {EndoMultiToothExamSurfaceAutofillConfigurationModel} from '../../../../models/forms/custom/mti/endo-multi-tooth-exam-surface-autofill-configuration.model';
import {StaticDataService} from '../../../../services/static-data.service';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';
import {TdoTableV2Component} from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {TdoDropdownChange} from '../../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import {ToothCanalConfigurationModel} from '../../../../models/configuration/tooth-canal-configuration.model';
import {EndoMultiToothExamSurfaceAutofillDetailConfigurationModel} from '../../../../models/forms/custom/mti/endo-multi-tooth-exam-surface-autofill-detail-configuration.model';
import {ToothSurfaceConfigurationModel} from '../../../../models/teeth/tooth-surface-configuration.model';

@Component({
  selector: 'app-probing-depth',
  templateUrl: './probing-depth.component.html',
  styleUrls: ['./probing-depth.component.scss']
})
export class ProbingDepthComponent implements OnInit {
  @ViewChild('autofillTable') autoFillTable: TdoTableV2Component;

  isLoading = true;
  cfgTeeth: ToothConfigurationModel[] = [];
  selectedTooth: ToothConfigurationModel;
  configs: EndoMultiToothExamSurfaceAutofillConfigurationModel[] = [];
  selectedAutofill: EndoMultiToothExamSurfaceAutofillConfigurationModel;

  probingEnums: EnumValidValueItemModel[] = [];
  toothSurfaceEnums: EnumValidValueItemModel[] = [];

  constructor(private toothService: ToothService,
              private staticDataService: StaticDataService,
              private mtiService: MtiService) { }

  ngOnInit(): void {
    if (this.staticDataService.isReady) {
      this.setupEnums();
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
         this.setupEnums();
        }
      });
    }
  }

  setupEnums() {
    this.toothSurfaceEnums = this.staticDataService.getValidValueItemsByValidValueName('enumToothSurface');
    this.probingEnums = this.staticDataService.getValidValueItemsByValidValueName('enumProbingDepth');
    this.toothService.getAllTeeth(ToothService.enumUnitedStatesToothGrouping).subscribe((res) => {
      this.cfgTeeth = res;
      this.mtiService.getSurfaceProbingAutofills().subscribe((res1) => {
        this.configs = res1;
        this.selectedAutofill = this.configs[0];
        this.selectedTooth = this.cfgTeeth.find(p => p.ToothId === this.selectedAutofill.ToothID);
        this.isLoading = false;
      });
    });
  }

  onRowSelected(event: TdoTableSelectionEvent) {
    this.selectedTooth = event.row.model as ToothConfigurationModel;
    if (this.autoFillTable)
      this.autoFillTable.updateData(this.selectedTooth.cfgToothSurfaces);
  }

  onDeleteClick(model: string) {

  }

  onNew(event: any) {

  }

  onSave() {

  }

  getToothNum(ToothId: string) {
    const t = this.cfgTeeth.find(p => p.ToothId === ToothId);
    if (t) {
      return t.cfgToothDescriptions[0].Notation;
    } else {
      return '';
    }
  }

  getSurfaceName(enumId: string) {
    if (!this.toothSurfaceEnums || (this.toothSurfaceEnums && this.toothSurfaceEnums.length === 0)) {
      return '';
    }
    const enu = this.toothSurfaceEnums.find(p => p.ValidValueItemId === enumId);
    if (enu) {
      return enu.ItemSValue;
    } else {
      return '';
    }
  }

  onProbeSelectionChange(event: TdoDropdownChange, model: ToothSurfaceConfigurationModel) {
    if (!event.isUserInput)
      return;
    let autofill = this.configs.find(p => p.ToothID === model.ToothId);
    if (!autofill) {
      autofill = new EndoMultiToothExamSurfaceAutofillConfigurationModel();
      autofill.ToothID = model.ToothId;
    }

    let detail = autofill.cfgEndoMultiToothExamSurfaceAutofillDetails.find(p => p.ToothSurfaceId === model.ToothSurfaceId);
    if (detail) {
      detail.enumProbingDepthID = event.value.ValidValueItemId;
    } else {
      detail = new EndoMultiToothExamSurfaceAutofillDetailConfigurationModel();
      detail.ToothSurfaceId = model.ToothSurfaceId;
      detail.enumProbingDepthID = event.value.ValidValueItemId;
      autofill.cfgEndoMultiToothExamSurfaceAutofillDetails.push(detail);
    }

    this.mtiService.saveSurfaceProbingAutofills([autofill]).subscribe((res) => {
      this.mtiService.getSurfaceProbingAutofills().subscribe((res1) => {
        this.configs = res1;
        this.isLoading = false;
        this.selectedAutofill = this.configs.find(p => p.ToothID === this.selectedTooth.ToothId);
      });
    });
  }

  getProbingValue(model: ToothSurfaceConfigurationModel) {
    const autofill = this.configs.find(p => p.ToothID === model.ToothId);
    if (autofill) {
      const detail = autofill.cfgEndoMultiToothExamSurfaceAutofillDetails.find(p => p.ToothSurfaceId === model.ToothSurfaceId);
      if (detail) {
        const enu = this.probingEnums.find(p => p.ValidValueItemId === detail.enumProbingDepthID);
        return enu;
      }
    }
    return '';
  }
}
